export default __webpack_public_path__ + "static/media/_dots_icon_dark.8a92860b.svg";